
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './types';

interface TechniqueNameFieldProps {
  form: UseFormReturn<FormValues>;
}

export const TechniqueNameField: React.FC<TechniqueNameFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="techniqueName"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Technique Name <span className="text-red-500">*</span></FormLabel>
          <FormControl>
            <Input 
              placeholder="Enter the name of the technique" 
              {...field} 
              value={field.value || ''} 
              required 
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
